import React from "react";

export default function MasterCardMore() {
  return (
    <body
      bgcolor="#FFFFFF"
      leftmargin="0"
      topmargin="0"
      text="#000000"
      link="#0000CC"
      vlink="#0000CC"
      alink="#0000CC"
    >
      <table width="536" border="0" cellpadding="0" cellspacing="0">
        <tr>
          <td width="10">
            <img src="/images/trans.gif" width="10" />
          </td>
          <td width="100%">
            <img src="/images/trans.gif" />
          </td>
        </tr>
        <tr>
          <td width="10">
            <img src="/images/trans.gif" width="10" />
          </td>
          <td valign="top" width="100%">
            <table width="100%" border="0" cellspacing="0" cellpadding="0">
              <tr>
                <td width="40%" align="left">
                  <img
                    src="/images/introducing.gif"
                    width="200"
                    height="44"
                    border="0"
                    alt="Introducing..."
                  />
                </td>
                <td width="60%" align="left">
                  <img
                    src="/images/mastercard-securecode.webp"
                    width="200"
                    height="100"
                    alt="MasterCard&reg; SecureCode"
                  />
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td width="10">
            <img src="/images/trans.gif" width="10" />
          </td>
          <td valign="top">
            <table width="100%" border="0" cellspacing="0" cellpadding="0">
              <tr>
                <td valign="top" width="100%">
                  <img src="/images/trans.gif" width="5" height="12" />
                </td>
              </tr>
              <tr>
                <td valign="top" width="100%">
                  <font face="Verdana, Arial, Helvetica, sans-serif" size="2">
                    MasterCard<sup>&reg;</sup>
                    SecureCode&#153; is a new service from MasterCard and your
                    card issuer that provides added protection when you buy
                    online. There is no need to get a new MasterCard or Maestro
                    <sup>&reg;</sup>
                    card. You choose your own personal MasterCard SecureCode and
                    it is never shared with any merchant. A private code means
                    added protection against unauthorized use of your credit or
                    debit card when you shop online.{" "}
                  </font>
                  <p>
                    <font face="Verdana, Arial, Helvetica, sans-serif" size="2">
                      Every time you pay online with your MasterCard or Maestro
                      card, a box pops up from your card issuer asking you for
                      your personal SecureCode, just like the bank does at the
                      ATM. In seconds, your card issuer confirms it's you and
                      allows your purchase to be completed.{" "}
                    </font>
                  </p>
                </td>
              </tr>
              <tr>
                <td valign="top" width="100%">
                  <img src="/images/trans.gif" width="5" height="12" />
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td>
                  <img
                    src="/images/MasterCard-Logo.svg.png"
                    width="72"
                    height="43"
                    align="left"
                    alt="MasterCard"
                  />
                </td>
                <td align="center">
                  <font face="Verdana, Arial, Helvetica, sans-serif" size="2">
                    To find out more about MasterCard SecureCode go to
                    www.mastercardsecurecode.com
                  </font>
                </td>
                <td>
                  <img
                    src="/images/NicePng_mastercard-png_1367187.png"
                    width="72"
                    height="43"
                    align="left"
                    alt="Maestro International"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <img src="/images/trans.gif" width="72" />
                </td>
                <td>
                  <div align="center">
                    <a
                      href="javascript:window.close();"
                      onMouseOut="changeImage('button', 'btn_close');"
                      onMouseOver="changeImage('button', 'btn_close_over');"
                    >
                      <img
                        src="/images/btn_close_over.gif"
                        name="button"
                        vspace="0"
                        border="0"
                        hspace="0"
                        alt="Close"
                      />
                    </a>
                  </div>
                </td>
                <td>
                  <img src="/images/trans.gif" width="72" />
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </body>
  );
}
